import {Stack, Typography, Button, Box} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import {AnalysisCard} from './analysiscard';
import {ProductCard} from '../../../Analysis/components/productCard';

import {Swiper, SwiperSlide} from 'swiper/react';
import {EffectCards, EffectCoverflow, Navigation} from 'swiper/modules';

import DynamicProgressBar from '../../../../components/progressBars/dynamicProgressBar';

import {AnimationLoadingScreenWithProgressBar} from '../../../../components/loading/loadingScreen';

import APIObjectsContext from '../../../../context/APIObjectsContext';
import MiscContext from '../../../../context/MiscContext';

import {Link} from 'react-router-dom';
import getHealthFunctions from '../../helperfunctions';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

// import required modules
import {Pagination} from 'swiper/modules';

import React, {useContext, useState, useEffect, useCallback, useRef} from 'react';
import {getRatingObjs, ratingsToObj} from '../../helperfunctions';
import {useProductsApi} from '../../../../api/products';
import {useLocation, useNavigate} from 'react-router-dom';
import {CLIENT_TYPES} from '../../../../api/clientconfig';
import {useClientApi} from '../../../../api/client';
import {getClientTypeFromOrgId} from '../../../../config/clientThemes';
import {ORGANIZATION_IDS} from '../../../../config/clientThemes';
import {getClientConfig} from '../../../../config/clientThemes';
import {parseProducts} from './parseRecoProducts';
import useGeoLocation from 'react-ipgeolocation';
import {useMemo} from 'react';
import HealthCategoryNav from '../../../../components/NavigationBar/HealthCategoryNavigationBar';
import {identifyClientType} from '../../../../utils/identifyClientType';
// componenet for result Analysis page

export const AnalysisPage = () => {
  const [clientType, setClientType] = useState(CLIENT_TYPES.DEFAULT);
  const clientConfig = getClientConfig(clientType);

  // useEffect( () => {
  //   // Determine client type based on your authentication or route
  //   const determineClientType = () => {
  //     const fromDoktor = window.localStorage.getItem( 'from_doktor' );
  //     if ( fromDoktor === 'true' ) {
  //       return CLIENT_TYPES.DOKTOR_CONNECT;
  //     }
  //     // Add logic for ATP detection
  //     const fromATP = window.localStorage.getItem( 'from_atp' );
  //     if ( fromATP === 'true' ) {
  //       return CLIENT_TYPES.ATP;
  //     }
  //     return CLIENT_TYPES.DEFAULT;
  //   };

  //   setClientType( determineClientType() );
  // }, [] );

  useEffect(() => {
    setClientType(identifyClientType());
  }, []);

  const getUserCountryLocation = useGeoLocation();
  const [userCountryLocation, setUserCountryLocation] = useState('');
  const location = useLocation();
  const [item, setItem] = useState(location.state.item);
  const navigate = useNavigate();
  const {userPlan} = useContext(MiscContext);
  const {userAssessmentID, setUserAssessmentID} = useContext(APIObjectsContext);
  const [sessionId, setSessionId] = useState(localStorage.getItem('session-id'));

  const [slideIndex, setSlideIndex] = useState(0);
  const [userGeoLocation, setUserGeoLocation] = useState('');
  const [resultsProcessed, setResultsProcessed] = useState([]);
  const [error, setError] = useState(null);
  const [isAtplFlow, setIsAtplFlow] = useState(window.localStorage.getItem('from_atp') === 'true' ? true : false);

  // Function to get the correct back navigation URL based on client type
  const getBackNavigationUrl = useCallback(() => {
    switch (clientType) {
      case CLIENT_TYPES.ATP:
        return '/atpl-results';
      case CLIENT_TYPES.HELLO_HEALTH:
        return '/hellohealth-results';
      case CLIENT_TYPES.DOKTOR_CONNECT:
        return '/results'; // Keep existing behavior for Doktor Connect
      default:
        return '/results'; // Default behavior
    }
  }, [clientType]);

  // In AnalysisPage component, add new states for org products
  const [orgProductsList, setOrgProductsList] = useState([]);
  const [productsList, setProductsList] = useState([]);
  // const [ clientType, setClientType ] = useState( () => {
  //   const orgId = localStorage.getItem( 'organization_id' );
  //   if ( orgId === '1' ) {
  //     return CLIENT_TYPES.DOKTOR_CONNECT;
  //   } else if ( orgId === '2' ) {
  //     return CLIENT_TYPES.ATP;
  //   }
  //   return CLIENT_TYPES.DEFAULT;
  // } );
  // const clientConfig = getClientConfig( clientType );
  const clientApi = useClientApi(clientType);
  const productsApi = useProductsApi();
  const [loading, setLoading] = useState(false);
  const [responseReturned, setResponseReturned] = useState(false);
  const [isSymptomCheckerPresent, setIsSymptomCheckerPresent] = useState(false);
  const [isLoading, setIsLoading] = useState({
    loadingNuralogix: false,
    loadingSymptomChecker: false,
  });

  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const isGalaxyFold = useMediaQuery('(max-width:280px)');
  const isLargeScreen = useMediaQuery(theme => theme.breakpoints.up('md'));
  const healthFunctions = getHealthFunctions(item.name);
  const scaledValue = healthFunctions.getValue(item.value);
  const statusColor = healthFunctions.getColor(item.value);
  const statusText = healthFunctions.getStatus(item.value);
  const paramValue = healthFunctions.getScaledValue(item.value);

  const [isFromDoktor, setIsFromDoktor] = useState(false);

  useEffect(() => {
    console.log(getUserCountryLocation, userCountryLocation);

    if (getUserCountryLocation.error) {
      setUserCountryLocation(null); // If there's an error, set the location to null
    } else if (getUserCountryLocation.country && !userCountryLocation) {
      setUserCountryLocation(getUserCountryLocation.country); // Set geoLocation once when it's available
    }
  }, [getUserCountryLocation, userCountryLocation]); // Run when geoLocation or error changes

  useEffect(() => {
    // Check localStorage for the flag
    const fromDoktor = window.localStorage.getItem('from_doktor');
    setIsFromDoktor(fromDoktor === 'true');
  }, []);

  useEffect(() => {
    console.log('Organization ID:', localStorage.getItem('organization_id'));
    console.log('Client Type:', clientType);
  }, [clientType]);

  useEffect(() => {
    const resultsProcessed = item.results
      .map(result => {
        if (!result?.ratings) {
          return null;
        }

        const ratingObj = ratingsToObj(result.ratings, result.value);
        const ratingObjsAll = getRatingObjs(result.ratings.scheme);

        // Only return object if we have valid ratingObj
        if (!ratingObj) {
          return null;
        }

        return {
          key: result.key,
          name: result.name,
          status: ratingObj,
          value: result.value,
          ratings: result.ratings,
          barData: ratingObjsAll,
          details: result.description,
          needsImprovement: ratingObj.needsImprovement ?? 0, // Provide default value
          diastolicbp: result.diastolicbp,
          diastolicbpRatings: result.diastolicbpRatings,
          diastolicbpDescription: result.diastolicbpDescription,
        };
      })
      .filter(Boolean)
      .sort((a, b) => (b.needsImprovement ?? 0) - (a.needsImprovement ?? 0));

    setResultsProcessed(resultsProcessed);
  }, [item]);

  //fetch organisation product2
  useEffect(() => {
    if (!item) {
      setLoading(false);
      return;
    }
    if (clientType && sessionId) {
      fetchOrgProductsFromApi(clientApi, sessionId);
    } else {
      if (userCountryLocation || userCountryLocation === null) {
        fetchProductsFromAimdFlow(productsApi, userAssessmentID, userCountryLocation);
      }
    }
  }, [item, userCountryLocation]);

  //fetch product for Aimd Flow
  const fetchProductsFromAimdFlow = async (productsApi, userAssessmentID, userCountryLocation) => {
    try {
      setLoading(true);

      //Create product recommendation for the user
      await productsApi.createProductRecommendation(userAssessmentID, userCountryLocation);

      // Fetch the recommended products
      const response = await productsApi.getRecommendedProducts(userAssessmentID);

      // Ensure response contains data and status is OK (200)
      if (response.status === 200 && response.data) {
        const formattedProducts = parseProducts(response.data, item?.name);
        setProductsList(formattedProducts);
        setError(null);
      } else {
        // Handle cases where no products are found
        setError('No products found');
        console.warn('No products found in the response');
      }
    } catch (error) {
      setError('Error fetching AIMD flow products');
      console.error('Error fetching AIMD flow products:', error);
    } finally {
      setLoading(false);
    }
  };

  //fetch products for org flow
  const fetchOrgProductsFromApi = async (clientApi, sessionId) => {
    setLoading(true); // Start loading state

    try {
      // Fetch the product recommendations from the API
      const response = await clientApi.getProductRecommendations(sessionId);

      // Check if the response is successful and contains data
      if (response.status === 200 && response.data) {
        const formattedProducts = parseProducts(response.data, item?.name);
        setOrgProductsList(formattedProducts);
        setError(null);
      } else {
        setError('No products found');
        console.log('Error in product fetch response');
      }
    } catch (error) {
      setError(error?.message || 'Error fetching products from API');
      console.error('Error fetching products from API:', error);
    } finally {
      // Ensure loading state is always reset at the end
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!item) {
      navigate(getBackNavigationUrl());
    }
  }, [item, navigate, getBackNavigationUrl]);

  console.log('Parsed product List', orgProductsList, productsList);

  const categories = useMemo(() => {
    return resultsProcessed.map((result, index) => ({
      id: result.key,
      name: result.name,
      display: result.name.split(' '), // Handle multi-line display if needed
    }));
  }, [resultsProcessed]);

  // Add a new state for category navigation
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);
  const swiperRef = useRef(null);

  return (
    <>
      {isLoading.loadingNuralogix && isLoading.loadingSymptomChecker ? (
        <AnimationLoadingScreenWithProgressBar
          title="Loading..."
          secondsToLoad={60}
          isAlmostComplete={responseReturned}
        />
      ) : isLargeScreen ? (
        <Stack
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          className="large-analysis-page-wrapper"
          paddingTop={5}
          paddingBottom={1}
        >
          <Stack className="large-analysis-page-card" padding={3}>
            {/* Top Header Starts */}
            <Stack
              className="top-header"
              display="flex"
              alignItems="center"
              flexDirection="row"
              justifyContent="space-between"
            >
              <Stack>
                <Link to={getBackNavigationUrl()} style={{textDecoration: 'none'}}>
                  <Stack display="flex" flexDirection="row" style={{cursor: 'pointer'}}>
                    {clientConfig.backButton}
                  </Stack>
                </Link>
                <Typography
                  color="black"
                  variant="h4"
                  component="h4"
                  fontWeight="bold"
                  sx={{
                    fontSize: '23px',
                  }}
                >
                  {item.name}
                </Typography>
                <Typography
                  color={statusColor}
                  variant="p"
                  component="p"
                  fontWeight="600"
                  sx={{
                    fontSize: '15px',
                  }}
                >
                  {statusText}
                </Typography>
              </Stack>
              <div
                style={{
                  position: 'relative',
                  width: '80px',
                  height: '80px',
                  background: '#fff',
                }}
              >
                <Box position="relative" display="inline-flex">
                  <DynamicProgressBar
                    paramValue={paramValue}
                    paramSize={80}
                    paramThickness={8}
                    barColor={statusColor}
                  />
                  <Typography
                    variant="h6"
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                    }}
                    sx={{fontWeight: 'bold'}}
                  >
                    {Number(Math.round(item.value))}
                  </Typography>
                </Box>
              </div>
            </Stack>

            {/* TXT Box Starts */}
            <Box>
              <Typography
                color="black"
                variant="h4"
                component="h4"
                fontWeight="bold"
                sx={{
                  fontSize: '23px',
                }}
              >
                {resultsProcessed[slideIndex]?.needsImprovement ? '👎 Needs Improvement...' : '👍 Looks Great!'}
              </Typography>
              <Typography
                marginTop="7px"
                color="black"
                variant="p"
                component="p"
                fontWeight="bold"
                sx={{
                  fontWeight: '500',
                  fontSize: '14px',
                  marginBottom: '10px',
                }}
              >
                {resultsProcessed[slideIndex]?.needsImprovement
                  ? 'The following health scores could be improved'
                  : "The following health scores are looking great! Keep doing what you're doing."}
              </Typography>
            </Box>

            <Stack className="large-analysis-slider">
              <Box sx={{marginBottom: '40px'}}>
                <Swiper
                  ref={swiperRef}
                  effect={'coverflow'}
                  grabCursor={true}
                  centeredSlides={true}
                  slidesPerView={2}
                  coverflowEffect={{
                    rotate: 0,
                    stretch: 0,
                    depth: 100,
                    modifier: 4,
                    slideShadows: false,
                  }}
                  pagination={
                    !isAtplFlow && clientType !== CLIENT_TYPES.DEFAULT
                      ? {
                          clickable: true,
                        }
                      : false
                  }
                  modules={[EffectCoverflow, Pagination, Navigation]}
                  onSlideChange={e => {
                    setSlideIndex(e.realIndex);
                    // Sync category navigation with swiper
                    setActiveCategoryIndex(e.realIndex);
                  }}
                  style={{
                    overflow: 'visible',
                  }}
                >
                  {resultsProcessed.map(result => (
                    <SwiperSlide
                      key={result.key}
                      style={{
                        overflow: 'visible',
                      }}
                    >
                      <AnalysisCard {...result} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Box>

              {/* Add Category Navigation */}
              {clientConfig?.resultPageSlider?.isResultPageSliderForAnalysisPageVisible && (
                <Box>
                  {categories.length > 0 && (
                    <HealthCategoryNav
                      categories={categories}
                      activeIndex={activeCategoryIndex}
                      onSelectCategory={index => {
                        setActiveCategoryIndex(index);
                        // Optional: Sync swiper with category selection
                        // Uncomment if you want the swiper to change when categories are clicked
                        swiperRef.current?.swiper.slideTo(index);
                      }}
                      isLargeScreen={true}
                      alignment="center"
                      indicatorpadding={2}
                      clientBaseNavCss={{
                        arrowColor: clientConfig?.resultPageSlider?.arrowColor,
                        arrowHOverColor: clientConfig?.resultPageSlider?.arrowHOverColor,
                        movingIndicatorColor: clientConfig?.resultPageSlider?.movingIndicatorColor,
                      }}
                    />
                  )}
                </Box>
              )}

              <Box marginTop="10px">
                <Typography
                  color="black"
                  variant="h4"
                  component="h4"
                  fontWeight="bold"
                  sx={{
                    fontWeight: 400,
                    fontSize: '10px',
                  }}
                >
                  These numbers are only estimates and are not a substitute for the judgment of a healthcare
                  professional. They are intended to improve awareness and general wellness.
                </Typography>
              </Box>
            </Stack>

            {/* Product Wrapper Starts */}
            <Stack>
              <Box marginTop="30px">
                <Typography
                  color="black"
                  variant="h4"
                  component="h4"
                  fontWeight="bold"
                  sx={{
                    fontWeight: 700,
                    fontSize: '23px',
                  }}
                >
                  💊 Products to Improve Your Health
                </Typography>
                <Typography
                  color="black"
                  variant="h4"
                  component="h4"
                  fontWeight="bold"
                  sx={{
                    fontWeight: 500,
                    marginTop: '5px',
                    fontSize: '14px',
                  }}
                >
                  Our recommendations are informed by real results and positive impacts observed in individuals who
                  share similar health profiles and lifestyle factors as yours.
                </Typography>
              </Box>

              <Stack className="large-product-slider">
                {clientType !== CLIENT_TYPES.DEFAULT ? (
                  // Organization workflow products
                  orgProductsList.length > 0 ? (
                    <Swiper
                      effect={'coverflow'}
                      grabCursor={true}
                      centeredSlides={true}
                      slidesPerView={2}
                      coverflowEffect={{
                        rotate: 0,
                        stretch: 0,
                        depth: 100,
                        modifier: 2.5,
                        slideShadows: false,
                      }}
                      pagination={{
                        clickable: true,
                      }}
                      modules={[EffectCoverflow, Pagination, Navigation]}
                      className="productSwiper"
                    >
                      {orgProductsList.map(product => (
                        <SwiperSlide key={product.id}>
                          <ProductCard productData={product} />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  ) : (
                    <Box className="dummy-product-box" marginLeft="auto" marginRight="auto" marginTop={2}>
                      <span>Loading ....</span>
                    </Box>
                  )
                ) : // Original default workflow products section
                productsList.length > 0 ? (
                  <Swiper
                    effect={'coverflow'}
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView={2}
                    coverflowEffect={{
                      rotate: 0,
                      stretch: 0,
                      depth: 100,
                      modifier: 2.5,
                      slideShadows: false,
                    }}
                    pagination={{
                      clickable: true,
                    }}
                    modules={[EffectCoverflow, Pagination, Navigation]}
                    className="productSwiper"
                  >
                    {productsList.map(product => (
                      <SwiperSlide key={product.id}>
                        <ProductCard productData={product} />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                ) : (
                  <Box className="dummy-product-box" marginLeft="auto" marginRight="auto" marginTop={2}>
                    <span>Loading ....</span>
                  </Box>
                )}
              </Stack>
            </Stack>
            {/* {isFromDoktor ?
                <Box>
                  <Box marginTop="30px">
                    <Typography
                      color="black"
                      variant="h4"
                      component="h4"
                      fontWeight="bold"
                      sx={{
                        fontWeight: 700,
                        fontSize: '30px',
                      }}
                    >
                      🕹️ Games to Reduce Stress & Improve Brain Health
                    </Typography>
                    <Box marginTop='50px'>
                      <img src="/games.jpeg" alt='product' />
                    </Box>

                  </Box>
                </Box>
                :
                <></>
              } */}
          </Stack>
        </Stack>
      ) : (
        // Existing code for smaller screens
        <Stack
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          className="analysis-page-wrapper"
          paddingTop={5}
          paddingBottom={1}
        >
          <Stack className="analysis-page-card" padding={3}>
            {/* Top Header Starts */}
            <Stack
              className="top-header"
              display="flex"
              alignItems="center"
              flexDirection="row"
              justifyContent="space-between"
            >
              <Stack>
                <Link to={getBackNavigationUrl()} style={{textDecoration: 'none'}}>
                  <Stack display="flex" flexDirection="row" style={{cursor: 'pointer'}}>
                    {clientConfig.backButton}
                  </Stack>
                </Link>
                <Typography
                  color="black"
                  variant="h4"
                  component="h4"
                  fontWeight="bold"
                  sx={{
                    fontSize: isGalaxyFold ? '18px' : isSmallScreen ? '23px' : '23px',
                  }}
                >
                  {item.name}
                </Typography>
                <Typography
                  color={statusColor}
                  variant="p"
                  component="p"
                  fontWeight="600"
                  sx={{
                    fontSize: isGalaxyFold ? '15px' : isSmallScreen ? '15px' : '15px',
                  }}
                >
                  {statusText}
                </Typography>
              </Stack>
              <div
                style={{
                  position: 'relative',
                  width: '80px',
                  height: '80px',
                  background: '#fff', // Add a contrasting background color
                }}
              >
                <Box position="relative" display="inline-flex">
                  <DynamicProgressBar
                    paramValue={paramValue}
                    paramSize={80}
                    paramThickness={8}
                    barColor={statusColor}
                  />

                  <Typography
                    variant="h6"
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                    }}
                    sx={{fontWeight: 'bold'}}
                  >
                    {Number(Math.round(item.value))}
                  </Typography>
                </Box>
              </div>
            </Stack>
            {/* Top Header Ends */}

            {/* TXT Box Starts */}

            <Box>
              <Typography
                color="black"
                variant="h4"
                component="h4"
                fontWeight="bold"
                sx={{
                  fontSize: isGalaxyFold ? '18px' : isSmallScreen ? '23px' : '23px',
                }}
              >
                {resultsProcessed[slideIndex]?.needsImprovement ? '👎 Needs Improvement...' : '👍 Looks Great!'}
              </Typography>
              <Typography
                marginTop="7px"
                color="black"
                variant="p"
                component="p"
                fontWeight="bold"
                sx={{
                  fontWeight: '500',
                  fontSize: isGalaxyFold ? '14px' : isSmallScreen ? '14px' : '14px',
                }}
              >
                {resultsProcessed[slideIndex]?.needsImprovement
                  ? 'The following health scores could be improved'
                  : "The following health scores are looking great! Keep doing what you're doing."}
              </Typography>
            </Box>
            {/* TXT Box Ends */}

            <Stack className="analysis-slider">
              <Box>
                <Swiper
                  ref={swiperRef}
                  slidesPerView={1}
                  spaceBetween={38}
                  onSlideChange={e => {
                    setSlideIndex(e.realIndex);
                    // Sync category navigation with swiper
                    setActiveCategoryIndex(e.realIndex);
                  }}
                  pagination={
                    !isAtplFlow && clientType !== CLIENT_TYPES.DEFAULT
                      ? {
                          clickable: true,
                        }
                      : false
                  }
                  className="mySwiper"
                  style={{
                    overflow: 'visible',
                  }}
                >
                  {resultsProcessed.map(result => {
                    return (
                      <SwiperSlide
                        key={result.key}
                        style={{
                          overflow: 'visible',
                        }}
                      >
                        <AnalysisCard {...result} />
                      </SwiperSlide>
                    );
                  })}
                </Swiper>

                {/* Category Nav */}
                {clientConfig?.resultPageSlider?.isResultPageSliderForAnalysisPageVisible && (
                  <Box>
                    {categories.length > 0 && (
                      <HealthCategoryNav
                        categories={categories}
                        activeIndex={activeCategoryIndex}
                        onSelectCategory={index => {
                          setActiveCategoryIndex(index);
                          // Optional: Sync swiper with category selection
                          // Uncomment if you want the swiper to change when categories are clicked
                          swiperRef.current?.swiper.slideTo(index);
                        }}
                        isLargeScreen={false}
                        alignment="center"
                        indicatorpadding={2}
                        clientBaseNavCss={{
                          arrowColor: clientConfig?.resultPageSlider?.arrowColor,
                          arrowHOverColor: clientConfig?.resultPageSlider?.arrowHOverColor,
                          movingIndicatorColor: clientConfig?.resultPageSlider?.movingIndicatorColor,
                        }}
                      />
                    )}
                  </Box>
                )}
              </Box>
              {/* Bottom Stuff Starts */}
              <Box marginTop="10px">
                <Typography
                  color="black"
                  variant="h4"
                  component="h4"
                  fontWeight="bold"
                  sx={{
                    fontWeight: 400,
                    fontSize: isGalaxyFold ? '10px' : isSmallScreen ? '10px' : '10px',
                  }}
                >
                  These numbers are only estimates and are not a substitute for the judgment of a healthcare
                  professional. They are intended to improve awareness and general wellness.
                </Typography>
              </Box>
              {/* Bottom Stuff Ends */}
            </Stack>

            {/* Product Wrapper Starts */}
            <Stack>
              {/* Product Header Starts */}
              <Box marginTop="30px">
                <Typography
                  color="black"
                  variant="h4"
                  component="h4"
                  fontWeight="bold"
                  sx={{
                    fontWeight: 700,
                    fontSize: isGalaxyFold ? '23px' : isSmallScreen ? '23px' : '23px',
                  }}
                >
                  💊 Products to Improve Your Health
                </Typography>
                <Typography
                  color="black"
                  variant="h4"
                  component="h4"
                  fontWeight="bold"
                  sx={{
                    fontWeight: 500,
                    marginTop: '5px',
                    fontSize: isGalaxyFold ? '14px' : isSmallScreen ? '14px' : '14px',
                  }}
                >
                  Our recommendations are informed by real results and positive impacts observed in individuals who
                  share similar health profiles and lifestyle factors as yours.
                </Typography>
              </Box>
              {/* Product Header Starts */}

              {/* Product SLider Starts */}
              <Stack className="product-slider">
                {clientType !== CLIENT_TYPES.DEFAULT ? (
                  // Organization workflow products
                  orgProductsList.length > 0 ? (
                    <Swiper
                      slidesPerView={1}
                      spaceBetween={30}
                      pagination={{
                        clickable: true,
                      }}
                      modules={[Pagination]}
                      className="productSwiper"
                    >
                      {orgProductsList.map(product => (
                        <SwiperSlide key={product.id}>
                          <ProductCard productData={product} />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  ) : (
                    <Box className="dummy-product-box" marginLeft="auto" marginRight="auto" marginTop={2}>
                      <span>Loading ....</span>
                    </Box>
                  )
                ) : // Original default workflow products section
                productsList.length > 0 ? (
                  <Swiper
                    slidesPerView={1}
                    spaceBetween={30}
                    pagination={{
                      clickable: true,
                    }}
                    modules={[Pagination]}
                    className="productSwiper"
                  >
                    {productsList.map(product => (
                      <SwiperSlide key={product.id}>
                        <ProductCard productData={product} />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                ) : (
                  <Box className="dummy-product-box" marginLeft="auto" marginRight="auto" marginTop={2}>
                    <span>Loading ....</span>
                  </Box>
                )}
              </Stack>
              {/* Product SLider Ends */}
            </Stack>

            {/* {
              isFromDoktor ?
                <Box>
                  <Box marginTop="10px">
                    <Typography
                      color="black"
                      variant="h4"
                      component="h4"
                      fontWeight="bold"
                      sx={{
                        fontWeight: 700,
                        fontSize: '23px',
                      }}
                    >
                      🕹️ Games to Reduce Stress & Improve Brain Health
                    </Typography>
                    <Box marginTop='20px'>
                      <img src="/games.jpeg" alt='product' />
                    </Box>
                  </Box>
                </Box>
                :
                <></>
              } */}
          </Stack>
        </Stack>
      )}
    </>
  );
};
